<template>
  <div class="height540 p50 white-bg">
    <div class="commonality-title">用户注册</div>
    <div class="borderTop pt50 flex ju-cn">
      <el-form
          class="demo-ruleForm"
          ref="lform"
          :model="signInform"
          :rules="rules"
          label-width="100px"
          style="width: 380px;">
        <el-form-item label="昵称" prop="account">
          <el-input name="name" v-model="signInform.account" placeholder="输入1-12字符，仅支持中英文"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
              name="password"
              type="password"
              v-model="signInform.password"
              autocomplete="off"
              placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
              name="checkPass"
              type="password"
              v-model="signInform.checkPass"
              autocomplete="off"
              placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="绑定邮箱" prop="email">
          <el-input name="email" v-model="signInform.email" placeholder="请输入"></el-input>
<!--          <el-autocomplete
              style="width: 100%;"
              name="email"
              v-model="signInform.email"
              :fetch-suggestions="querySearch"
              placeholder="请输入"
              @select="handleSelect"
          ></el-autocomplete>-->
        </el-form-item>
        <el-form-item label="邮箱验证码" prop="captcha">
          <el-input name="email" v-model="signInform.captcha" placeholder="请输入">
            <el-button
                slot="suffix"
                :disabled="countdown > 0"
                size="mini"
                type="text"
                @click="sendEmail">
              {{ countdown > 0 ? `${countdown}秒后重新发送` : '获取验证码' }}
            </el-button>
          </el-input>
        </el-form-item>
        <div class="flex ju-cn ptb20">
          <el-button type="primary" @click="signIn" style="width: 150px;">注册</el-button>
        </div>
<!--        <div class="flex al-cn ju-cn">
          <el-checkbox v-model="checked">
            <div class="cl333 f12">我已阅读并同意</div>
          </el-checkbox>
          <div class="f12 cl0066FF pointer" @click="dialogVisible = true">《用户注册协议》</div>
        </div>-->
      </el-form>
<!--      <el-dialog title="注册协议" :visible.sync="dialogVisible" width="60%">
        <div v-html="registrationAgreement"></div>
      </el-dialog>-->
    </div>
  </div>
</template>

<script>
import {register, sendCode} from "@/api/api";

export default {
  data() {
    return {
      checked: false,
      labelPosition: "right",
      countdown: 0,
      emailSuggestions: [
        {value: "@qq.com"},
        {value: "@123.com"},
        {value: "@163.com"}
      ],
      signInform: {
        account: "",
        password: "",
        checkPass: "",
        email: "",  // 默认值为空
        captcha: ""
      },
      rules: {
        account: [
          {required: true, message: "请输入账号", trigger: "blur"},
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,12}$/,
            message: "请输入1-12字符，仅支持中英文",
            trigger: "blur"
          }
        ],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        checkPass: [
          {required: true, message: "请再次输入密码", trigger: "blur"},
          {
            validator: (rule, value, callback) => {
              if (value !== this.signInform.password) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        email: [
          {required: true, message: "请输入邮箱", trigger: "blur"},
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱",
            trigger: "blur"
          }
        ],
        captcha: [
          {required: true, message: "请输入邮箱验证码", trigger: "blur"}
        ]
      },
      registrationAgreement: '', // 注册协议
      dialogVisible: false,
    };
  },
  mounted() {
    // this.getSetting();
  },
  methods: {
    // 获取注册协议
    getSetting() {
      getSetting().then(res => {
        if (res.code === 200) {
          this.registrationAgreement = res.data.register_doc;
        }
      })
    },
    // 邮箱搜索
    querySearch(queryString, cb) {
      const results = queryString ? this.emailSuggestions.map(email => {
        const atIndex = queryString.indexOf('@');
        const prefix = atIndex !== -1 ? queryString.substring(0, atIndex) : queryString;
        return {value: `${prefix}${email.value}`};
      }) : this.emailSuggestions;
      cb(results);
    },
    // 选择邮箱
    handleSelect(item) {
      this.signInform.email = item.value;
    },
    createFilter(queryString) {
      return (email) => {
        return email.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      const interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 发送验证码
    async sendEmail() {
      if (this.signInform.email) {
        sendCode({
          email: this.signInform.email,
          fla: 1 // 注册
        }).then(res => {
          if (res.code === 200) {
            this.$message({message: "发送成功", type: "success"});
            this.startCountdown();
          } else {
            this.message = '验证码发送失败，请稍后再试';
          }
        }).catch(error => {
          // this.message = '请求出错，请检查网络连接';
        }) /**/
      } else {
        this.message = '请输入邮箱地址';
      }
    },
    // 注册
    signIn() {
      this.$refs.lform.validate(valid => {
        if (valid) {
          this.loading = true;
          register(this.signInform).then(res => {
            this.loading = false;
            if (res.code === 200) {
              sessionStorage.setItem("token", res.data.token);
              this.$store.commit('setToken', res.data.token)
              this.resetForm('lform')
              this.$router.push({path: "/"}); // 跳转路由
            }
          }).catch(err => {
            this.loading = false;
            console.log('请求错误', err)
            this.$message({
              message: "网络或程序异常！" + err,
              type: "error"
            });
          });
        } else {
          this.$message({
            message: "请输入合法的值",
            type: "error"
          });
          return false;
        }
      });
    },
// 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
